import { OpenLRGeoCoordinate } from './openlrgeocoordinate.model';
import { OpenLRLineAttributes } from './openlrlineattributes.model';

export class OpenLRLastLocationReferencePoint {
  openlrGeoCoordinate: OpenLRGeoCoordinate;
  openlrLineAttributes: OpenLRLineAttributes;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrlastlocationreferencepoint.model.ts